/**
 * Spoiler free daily result line. Pure, so the test runs the exact text the
 * game copies. It names the date and the streak only: never the board, the
 * node, or the move.
 */
export function dailyShareText(dateLabel: string, streak: number): string {
  const n = Math.max(1, Math.floor(streak) || 1);
  return `NØDUS DAILY ${dateLabel}\nSolved, streak x${n}\nhayterwave.com/nodus`;
}
